<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Usuário</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.nome.value"
            />
            <span v-if="state.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-4">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              class="form-control"
              placeholder="Digite um email:"
              v-model="state.email.value"
            />
            <span v-if="state.email.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-4">
            <label for="password">Senha</label>
            <input
              id="password"
              type="password"
              class="form-control"
              placeholder="Digite uma senha:"
              v-model="state.password.value"
            />
            <span v-if="state.password.error" class="text-danger"
              >Este campo é obrigatório / </span
            >
            <span v-if="state.caracter" class="text-danger"
              >O campo password deve ter no mínimo 8 caracteres.</span
            >
          </div>
          <div class="col-md-4">
            <label for="status">Status</label>
            <select v-model="state.status" class="form-select">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarUsuario" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/usuarios">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: {
        value: "",
        error: false,
      },
      email: {
        value: "",
        error: false,
      },
      password: {
        value: "",
        error: false,
      },
      caracter: false,
      status: "ATIVO",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchUsuario();
      }
    });
    async function fetchUsuario() {
      try {
        const { data } = await services.usuario.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome.value = data.name;
        state.email.value = data.email;
        state.password.value = data.password;
        state.status = data.status;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarUsuario() {
      var erro_validacao = false;

      if (state.nome.value.length == 0) {
        state.nome.error = true;
        erro_validacao = true;
      }
      if (state.email.value.length == 0) {
        state.email.error = true;
        erro_validacao = true;
      }
      if (state.password.value.length == 0) {
        state.password.error = true;
        erro_validacao = true;
      }
      if (state.password.value.length < 8) {
        state.caracter = true;
        alert("Campo password deve ter no minimo 8 caracteres, caso esteja atualizando o usuario, insira a nova senha!");

        return;
        
      }

      if (erro_validacao == true) {
        return;
      }

      if (!state.id) {
        await services.usuario
          .save({
            name: state.nome.value,
            email: state.email.value,
            password: state.password.value,
            status: state.status,
            token,
          })
          .then((data) => {
            console.log(data);
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        await services.usuario.update({
          id: state.id,
          name: state.nome.value,
          email: state.email.value,
          password: state.password.value,
          status: state.status,
          token,
        });
        router
          .push({ name: "Usuarios" })
          .then((data) => {
            console.log(data);
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    return {
      salvarUsuario,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 5rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.imagem {
  width: 100%;
  object-fit: cover;
  margin-top: 1rem;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: #8b0000;
  color: #fff;
  border: solid 1px #8b0000;
  border-radius: 5px;
  transition: 0.3s;
  margin-top: 1rem;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>